import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import refurbishers from '../views/refurbishers.vue'
import donors from '../views/donors.vue'
import npos from "../views/npos.vue"
import account from '../views/account.vue'
import login from '../views/login.vue'
import PageNotFound from "../views/404.vue"
import * as fb from '../../firebaseconfig'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: '/refurbishers',
    name: 'Refurbishers',
    component: refurbishers,
    meta: { requiresAuth: true }
  },
  {
    path: '/npos',
    name: 'NPOs',
    component: npos,
    meta: { requiresAuth: true }
  },
  {
    path: '/donors',
    name: 'Donors',
    component: donors,
    meta: { requiresAuth: true }
  },
  { path: "*", component: PageNotFound },
  {
    path: '/account',
    name: 'Account',
    component: account,
    meta: { requiresAuth: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    fb.auth.onAuthStateChanged(user => {
      if (!user) {
        next({
          path: "/"
        })
      } else {
        next()
      }
    })
    // this route requires auth, check if logged in
    // if not, redirect to login page.
  } else {
    next() // make sure to always call next()!
  }
})
export default router
